var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("请先选择病种")]),_vm._v(" "),_c('div',{staticClass:"dislist"},_vm._l((_vm.dislist),function(item,index){return _c('div',{staticClass:"disitem",on:{"click":function($event){return _vm.godiscont(item.link)}}},[_c('img',{attrs:{"src":item.imgsrc}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8c1724","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dislistpage/dislistpage.vue
// module id = null
// module chunks = 